import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  throw new Error('Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY environment variables');
}

// No-op lock to prevent "Lock broken by another request with the 'steal' option" errors
// This happens when navigator.locks API conflicts between concurrent auth operations
const lockNoOp = async (_name, _acquireTimeout, fn) => {
  return await fn();
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    lock: lockNoOp,
    storageKey: 'pp-auth',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
